const styles = () => ({
  root: {
    width: "100%",
  },
  media: {},
});

export default styles;
